import type { LegalRoleFilter, LegalSection } from "./legal-types";

function sectionMatchesRole(section: LegalSection, role: LegalRoleFilter): boolean {
  if (role === "ALL") {
    return true;
  }

  if (section.audiences.includes("ALL")) {
    return true;
  }

  return section.audiences.includes(role);
}

function filterSectionsByRole(sections: LegalSection[], role: LegalRoleFilter): LegalSection[] {
  if (role === "ALL") {
    return sections;
  }

  return sections.filter((section) => sectionMatchesRole(section, role));
}

function isSectionHighlighted(section: LegalSection, role: LegalRoleFilter): boolean {
  if (role === "ALL") {
    return false;
  }

  return !section.audiences.includes("ALL") && section.audiences.includes(role);
}

export { filterSectionsByRole, isSectionHighlighted, sectionMatchesRole };
